import { useIsLoggedIn, useIsLoggingIn } from '@order/AuthMachine';
import { useIsCustomerSessionReady } from '@order/hooks';

import { useCheckoutContext } from '../../CheckoutProvider';

export const useConnectedCheckoutRenderControl = () => {
  const context = useCheckoutContext();

  return useCheckoutRenderControl(context);
};

export const useCheckoutRenderControl = (
  props: Pick<
    ReturnType<typeof useCheckoutContext>,
    | 'cart'
    | 'isFetchingCart'
    | 'isCartDelivery'
    | 'isLoadingCredits'
    | 'isLoadingDeliveryEstimate'
    | 'isChangingOrderAddress'
    | 'isCartEmpty'
  >,
) => {
  const {
    cart,
    isFetchingCart,
    isCartDelivery,
    isLoadingCredits,
    isLoadingDeliveryEstimate,
    isChangingOrderAddress,
    isCartEmpty,
  } = props;

  const isLoggingIn = useIsLoggingIn();
  const isLoggedOut = !useIsLoggedIn();
  const isCustomerSessionReady = useIsCustomerSessionReady();

  const hasCart = !isCartEmpty && Boolean(cart?.id);
  const hasCartAddressIfNeeded =
    !isCartDelivery || Boolean(cart?.deliveryOrderDetail?.address?.id);

  const isLoadingCheckout =
    isFetchingCart ||
    isLoggingIn ||
    isLoadingCredits ||
    isLoadingDeliveryEstimate;
  const isCustomerDataReady = Boolean(
    isCustomerSessionReady && !isChangingOrderAddress,
  );
  const isCartValid = Boolean(
    isCustomerDataReady && hasCart && hasCartAddressIfNeeded,
  );

  return {
    isLoggedOut,
    isLoadingCheckout,
    isCustomerDataReady,
    isCartValid,
  };
};
